export default "__VITE_ASSET__CfaDR_3V__"